import type { RouteLocationNormalized } from "vue-router";
import consola from 'consola'
import { defineNuxtRouteMiddleware, navigateTo } from "#app";

/**
 * Middleware для обработки сброса пароля через токен из URL.
 * Проверяет токен и открывает модал с данными пользователя.
 */
export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized) => {
  // Извлекаем токен из query-параметров
  const token = to.query.token as string | undefined;
  
  consola.log('🔄 Reset password middleware called');
  consola.log('🔍 Token from URL:', token);
  consola.log('🖥️ Process client:', process.client);

  // Если токена нет, перенаправляем на главную
  if (!token) {
    consola.log('❌ No token found, redirecting to home');
    return navigateTo('/');
  }

  // Обрабатываем токен только на клиенте
  if (process.client) {
    consola.log('🔍 Processing token on client side');
    
    try {
      const { useModalStore } = await import('@shared/model');
      const { modalStateEnum } = await import('~/utils/enums/modalStateEnum');
      const APIAuth = await import('~/entities/auth/api');
      
      const modalStore = useModalStore();
      
      consola.log('🌐 Verifying token with API...');
      // Проверяем токен с сервером
      const response = await APIAuth.default.verifyResetToken({ token });
      
      consola.log('✅ API response:', response);
      
      if (response.data?.user) {
        consola.log('👤 User data received:', response.data.user);
        
        // Сохраняем токен и данные пользователя в modalStore
        modalStore.updateModalData({
          token,
          user: response.data.user,
        });
        
        consola.log('🎯 Opening ResetPassword modal');
        // Открываем модал
        modalStore.open(modalStateEnum.ResetPassword);
        
        consola.log('✅ Modal opened with user data');
        consola.log('📦 Modal data:', modalStore.modalData);
        
        // Небольшая задержка перед редиректом
        await new Promise(resolve => setTimeout(resolve, 100));
        
        consola.log('🏠 Redirecting to home page');
        return navigateTo('/');
        
      } else {
        consola.error("❌ Invalid reset token or no user data");
        alert('Недействительная ссылка для сброса пароля');
        return navigateTo('/');
      }
      
    } catch (error: any) {
      consola.error("❌ Error verifying reset token:", error);
      consola.error("Error details:", error.response?.data || error.message);
      alert('Ошибка при проверке ссылки сброса пароля');
      return navigateTo('/');
    }
  } else {
    // На сервере просто пропускаем обработку
    consola.log('🖥️ Server side, skipping token processing');
  }
}); 